import utils from "./index.js"

//js高精度加法算法
const addition = function (numA, numB) {
    let strA = numA + '',
        strB = numB + '',
        index = 0,
        bitA = strA.lastIndexOf("."),
        bitB = strB.lastIndexOf(".");
    //处理有小数点的数据
    if (bitA > 0 || bitB > 0) {
        //计算小数点位置
        index = bitA = bitA > 0 ? strA.length - 1 - bitA : 0;
        bitB = bitB > 0 ? strB.length - 1 - bitB : 0;
        //设置小数点补偿 0 
        if (bitA > bitB) {
            index = bitA
            strB += "0".repeat(bitA - bitB)
        } else if (bitA < bitB) {
            index = bitB
            strA += "0".repeat(bitB - bitA)
        }
        //去掉小数点，再进行计算
        strA = strA.replace(".", "")
        strB = strB.replace(".", "")
    }

    let arrA = strA.split(''),
        arrB = strB.split(''),
        lA = arrA.length,
        lB = arrB.length,
        arrC = [],
        i = 0;
    //进行加法算法
    for (; i < lA; i++) {
        arrA[lA - i - 1] = Number(arrA[lA - i - 1]) + Number(arrB[lB - i - 1] || 0) + ''
    }
    arrC = arrB.splice(0, lB - i)
    arrC = arrC.concat(arrA)
    // arrC = arrA
    //对结果进行满十进一
    for (let j = arrC.length - 1; j > 0; j--) {
        if (arrC[j].length > 1) {
            arrC[j - 1] = Number(arrC[j - 1]) + Number(arrC[j].substr(0, 1)) + ''
            arrC[j] = arrC[j].substr(1, 2)
        }
    }
    //对结果添加小数点
    index > 0 && arrC.splice(arrC.length - index, 0, '.');
    let strC = arrC.join("")
    //去掉前面的多余的0
    // strC = strC.replace(/^0+([0-9])/, '$1');
    return strC
}

//减法
const subtraction = function (numA, numB) {
    let strA = numA + '',
        strB = numB + '',
        index = 0,
        bitA = strA.lastIndexOf("."),
        bitB = strB.lastIndexOf(".");
    //处理有小数点的数据
    if (bitA > 0 || bitB > 0) {
        //计算小数点位置
        index = bitA = bitA > 0 ? strA.length - 1 - bitA : 0;
        bitB = bitB > 0 ? strB.length - 1 - bitB : 0;
        //设置小数点补偿 0 
        if (bitA > bitB) {
            index = bitA
            strB += "0".repeat(bitA - bitB)
        } else if (bitA < bitB) {
            index = bitB
            strA += "0".repeat(bitB - bitA)
        }
        //去掉小数点，再进行计算
        strA = strA.replace(".", "")
        strB = strB.replace(".", "")
    }

    let sla = strA.length,
        slb = strB.length,
        // 给前面补零
        arrA = ("0".repeat(slb - sla > 0 ? slb - sla : 0) + strA).split(''),
        arrB = ("0".repeat(sla - slb > 0 ? sla - slb : 0) + strB).split(''),
        lA = arrA.length,
        lB = arrB.length,
        arrC = [],
        isNegative = false,
        i = 0,
        //相等数位数
        n = 0;
    //计算是否为负数
    for (; n < lA; n++) {
        if (arrA[n] > arrB[n]) {
            isNegative = false
            break;
        } else if (arrA[n] < arrB[n]) {
            isNegative = true
            break;
        }
    }
    //如果是负数
    if (isNegative) {
        arrC = arrA
        arrA = arrB
        arrB = arrC
    }
    //如果有小数点，不能去掉过多的0
    if (index > 0) {
        n = 0
    }
    //进行减法算法
    for (; i < lA - n; i++) {
        arrA[lA - i - 1] = Number(arrA[lA - i - 1]) - Number(arrB[lB - i - 1] || 0) + ''
    }

    arrA.splice(0, n)
    arrC = arrA
    //对结果进行不足减一
    for (let j = arrC.length - 1; j > 0; j--) {
        if (arrC[j] < 0) {
            arrC[j - 1] = Number(arrC[j - 1]) - 1 + ''
            arrC[j] = 10 + Number(arrC[j]) + ''
        }
    }
    //对结果添加小数点
    index > 0 && arrC.splice(arrC.length - index, 0, '.');
    let strC = arrC.join("")
    //去掉小数点前面多余的0
    strC = strC.replace(/^0+([0-9])/, '$1');
    //去掉小数点后面多余的0
    strC = strC.replace(/(?:\.0*|(\.\d+?)0+)$/, "$1")
    strC = isNegative ? '-' + strC : strC
    return strC || '0'
}

//乘法
const multiplication = function (numA, numB) {
    let strA = numA + '',
        strB = numB + '',
        index = 0,
        bitA = strA.lastIndexOf("."),
        bitB = strB.lastIndexOf(".");
    //处理有小数点的数据
    if (bitA > 0 || bitB > 0) {
        bitA = bitA > 0 ? strA.length - 1 - bitA : 0;
        bitB = bitB > 0 ? strB.length - 1 - bitB : 0;
        //计算小数点位置
        index = bitA + bitB
        //去掉小数点，再进行计算
        strA = strA.replace(".", "")
        strB = strB.replace(".", "")
    }

    let arrA = strA.split(''),
        arrB = strB.split(''),
        lA = arrA.length,
        lB = arrB.length,
        arrC = [];


    //进行算法
    for (let i = lA - 1; i >= 0; i--) {
        let arrD = []
        for (let j = 0; j < lB; j++) {
            let obj = Number(arrA[i]) * Number(arrB[j] || 0) + ''
            arrD.push(obj)
        }
        //对结果进行满十进一
        for (let k = arrD.length - 1; k > 0; k--) {
            if (arrD[k].length > 1) {
                arrD[k - 1] = Number(arrD[k - 1]) + Number(arrD[k].substr(0, 1)) + ''
                arrD[k] = arrD[k].substr(1, 2)
            }
        }
        arrC.push(arrD.join(""))
    }

    let sum = '0'
    //对结果进行处理
    for (var j = arrC.length - 1; j >= 0; j--) {
        let numB = arrC[j] + '0'.repeat(j)
        sum = addition(sum, numB)
    }
    arrC = sum.split('')
    //对结果添加小数点
    index > 0 && arrC.splice(arrC.length - index, 0, '.');
    let strC = arrC.join("")
    return strC
}

//除法；逻辑为，取除数的前面与被除数相同长度数字去减被除数。
const division = function (numA, numB) {
    if(!numB)return '0'
    let strA = numA + '',
        strB = numB + '',
        index = 0,
        bitA = strA.lastIndexOf("."),
        bitB = strB.lastIndexOf(".");
    //处理有小数点的数据
    if (bitA > 0 || bitB > 0) {
        bitA = bitA > 0 ? strA.length - 1 - bitA : 0;
        bitB = bitB > 0 ? strB.length - 1 - bitB : 0;
        //计算小数点位置
        index = bitA - bitB
        //去掉小数点，再进行计算
        strA = strA.replace(".", "")
        strB = strB.replace(".", "")
    }
    let sum = "0"
    let strC = "0",
    lA = strA.length,
    lB = strB.length,
    //当前的除数
    divisorStr="",
    //剩下的除数
    remainder="";
    if(lA>lB){
        divisorStr=strA.substr(0,lB)
        remainder=strA.substr(lB,lA-lB)
    }else{
        divisorStr=strA
    }
    //进行算法,一次次减法，直到减到负数。在补零继续减，直到结果超过500字符长度
    do {
        strC = subtraction(divisorStr, strB)
        if (strC.indexOf("-") > -1) {
            //如果剩下的除数还有，继续取下一位进行计算
            if(remainder){
                divisorStr = divisorStr +remainder.substr(0,1)
                remainder=remainder.substr(1,remainder.length)
            }else{
                index++
                divisorStr = divisorStr + "0".repeat(1)
            }
            sum = sum + "0"
        } else {
            divisorStr = strC
            sum = addition(sum, 1)
        }
    } while ((strC != "0" || remainder)&&!(divisorStr.length>strA.length&&(divisorStr*1)==0) && sum.length < 500)

    //对结果进行补小数点。
    if (index > 0) {
        if(sum.length-index<0){
            sum="0".repeat(index-sum.length)+sum
        }
        sum=sum.slice(0,-index)+"."+sum.slice(-index)
    } else if (index < 0) {
        sum += "0".repeat(-index)
    }
    if (index > 0 && index + 1 == sum.length) {
        sum = "0" + sum
    }
    return sum
}

//比较两个数字字符串大小，isEqual 是否比较相等
const numberRatio = function (numA, numB ,isEqual) {
    let strA = numA + '',
        strB = numB + '',
        nA = strA.lastIndexOf("-"),
        nB = strB.lastIndexOf("-"),
        bitA = strA.lastIndexOf("."),
        bitB = strB.lastIndexOf(".");
    if (!utils.isNumber(strA) || !utils.isNumber(numB)) return false
    if(isEqual&&strA==strB)return true
    if(!isEqual&&strA==strB)return false
    //如果A为负数，B为正数，则直接返回结果
    if (nA > -1 && nB == -1) {
        return false
    } else if (nA == -1 && nB > -1) {
        return true
    }
    //处理有小数点的数据
    if (bitA > 0 || bitB > 0) {
        //计算小数点位置
        bitA = bitA > 0 ? strA.length - 1 - bitA : 0;
        bitB = bitB > 0 ? strB.length - 1 - bitB : 0;
        //设置小数点补偿 0 
        if (bitA > bitB) {
            strB += "0".repeat(bitA - bitB)
        } else if (bitA < bitB) {
            strA += "0".repeat(bitB - bitA)
        }
        //去掉小数点，再进行计算
        strA = strA.replace(".", "")
        strB = strB.replace(".", "")
    }
    //去掉负数符号
    strA = strA.replace("-", "")
    strB = strB.replace("-", "")
    let sla = strA.length,
        slb = strB.length,
        // 给前面补零
        arrA = ("0".repeat(slb - sla > 0 ? slb - sla : 0) + strA).split(''),
        arrB = ("0".repeat(sla - slb > 0 ? sla - slb : 0) + strB).split(''),
        lA = arrA.length,
        isNegative = true,
        //相等数位数
        n = 0;
    //计算是否为负数
    for (; n < lA; n++) {
        if (arrA[n] > arrB[n]) {
            isNegative = true
            break;
        } else if (arrA[n] < arrB[n]) {
            isNegative = false
            break;
        }
    }
    //两个数都时负数，则结果相反
    return nA > -1 ? !isNegative : isNegative
}
export default {
    addition(numA, numB) {
        return addition(numA, numB)
    },
    //加法
    add(numA, numB) {
        let strA = numA + '',
            strB = numB + '',
            strC='',
            nA = strA.lastIndexOf("-")>-1,
            nB = strB.lastIndexOf("-")>-1;
        //去掉负数符号
        strA = strA.replace("-", "")
        strB = strB.replace("-", "")
        //如果都有负号，这相加后添加负号,如果其中一个有，就时相减
        if(nA&&nB){
            strC = "-"+addition(strA, strB)
        }else if(nA&&!nB){
            strC = subtraction(strB,strA)
        }else if(!nA&&nB){
            strC = subtraction(strA,strB)
        }else{
            strC = addition(strA, strB)
        }
        //去掉小数点前面多余的0
        strC = strC.replace(/^0+([0-9])/, '$1');
        //去掉小数点后面多余的0
        strC = strC.replace(/(?:\.0*|(\.\d+?)0+)$/, "$1")
        return strC
    },
    //减法
    sub(numA, numB) {
        let strA = numA + '',
            strB = numB + '',
            strC='',
            nA = strA.lastIndexOf("-")>-1,
            nB = strB.lastIndexOf("-")>-1;
        //去掉负数符号
        strA = strA.replace("-", "")
        strB = strB.replace("-", "")
        
        if(nA&&nB){
            strC = subtraction(strA, strB)
            if(strC.indexOf("-")>-1){
                strC=strC.replace("-","")
            }else{
                strC="-"+strC
            }
        }else if(nA&&!nB){
            strC = "-"+addition(strA,strB)
        }else if(!nA&&nB){
            strC = addition(strA,strB)
        }else{
            strC = subtraction(strA, strB)
        }
        return strC
    },
    //乘法
    mul(numA, numB) {
        if(numA===null||numB==null)return "0"
        let strA = numA + '',
            strB = numB + '',
            strC='',
            nA = strA.lastIndexOf("-")>-1,
            nB = strB.lastIndexOf("-")>-1;
        //去掉负数符号
        strA = strA.replace("-", "")
        strB = strB.replace("-", "")
        strC = multiplication(strA, strB)
        //去掉小数点前面多余的0
        strC = strC.replace(/^0+([0-9])/, '$1');
        //去掉小数点后面多余的0
        strC = strC.replace(/(?:\.0*|(\.\d+?)0+)$/, "$1")
        //如果有一数时负数，则结果为负
        if((nA&&!nB)||(!nA&&nB)){
            strC = "-"+strC
        }
        return strC
    },
    //除法
    div(numA, numB) {
        let strA = numA + '',
            strB = numB + '',
            strC='',
            nA = strA.lastIndexOf("-")>-1,
            nB = strB.lastIndexOf("-")>-1;
        //去掉负数符号
        strA = strA.replace("-", "")
        strB = strB.replace("-", "")
        strC = division(strA, strB)
        //去掉小数点前面多余的0
        strC = strC.replace(/^0+([0-9])/, '$1');
        //去掉小数点后面多余的0
        strC = strC.replace(/(?:\.0*|(\.\d+?)0+)$/, "$1")
        if((nA&&!nB)||(!nA&&nB)){
            strC = "-"+strC
        }
        return strC
    },
    ratio(numA, numB , isEqual) {
        return numberRatio(numA, numB , isEqual)
    }

}



// WEBPACK FOOTER //
// ./src/utils/arithmetic.js